import styled from "styled-components";


export const QuizQuestionQuill = styled.div`
  border-bottom: 1px solid #f2f2f2;
`;